import gql from 'graphql-tag';

export default gql`
  mutation createRegularBooking(
    $restaurantId: Int!
    $date: String!
    $time: String!
    $covers: Int!
    $options: String
  ) {
    createRegularBooking(
      restaurantId: $restaurantId
      date: $date
      time: $time
      people: $covers
      options: $options
    ) {
      reference
      status
    }
  }
`;
